import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { KeycloakService } from 'keycloak-angular';

export const authHeadersInterceptor: HttpInterceptorFn = (req, next) => {
  const keycloak = inject(KeycloakService);
  const token = keycloak.getKeycloakInstance().token;

  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  };

  if (
  (req.url.includes('/off_highway/dashboard/totalOpportunity/cagr') ||
   req.url.includes('/off_highway/dashboard/totalOpportunity/validate')) &&
  token
) {
  headers['Authorization'] = `Bearer ${token}`;
}

  const cloned = req.clone({
    setHeaders: headers,
  });

  return next(cloned);
};
